/* Open the native time/date picker on tap — Android WebView doesn't always open it for hidden or segmented inputs. */
export const openPicker = (input) => {
  if (!input) return;
  try { if (typeof input.showPicker === 'function') { input.showPicker(); return; } } catch { /* fall back */ }
  input.focus();
  input.click();
};
